import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=0287dab0&v-on-clickaway=cancel&class=order-reservation-details&"
import script from "./Edit.vue?vue&type=script&lang=ts&"
export * from "./Edit.vue?vue&type=script&lang=ts&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=0287dab0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports